/* Generated from shared/app-shell/AppShell.jsx. Do not edit this copy. */
// Canonical template for Cooking, F1 and Wallet. Edit this file, then run
// node scripts/sync-app-shell.cjs. App-local copies support independent deployments.
import React from 'react';
import './AppShell.css';

export const appShells = {
  cooking: {
    title: 'cooking', home: '#recipes', icon: 'leaf',
    tagline: 'Everyday cooking, made yours.',
    note: ['A little planning.', 'A lot of good food.'], account: 'Your personal kitchen',
    footer: 'BRECK COOKING', footerNote: 'Recipes worth keeping. Meals worth making.',
    groups: [{ label: 'YOUR KITCHEN', items: [
      { href: '#recipes', label: 'Recipes', icon: 'recipes' },
      { href: '#shopping', label: 'Shopping lists', icon: 'shopping', badge: 'shopping' },
      { href: '#fridge', label: 'In my fridge', icon: 'fridge' },
      { href: '#calendar', label: 'Meal planner', icon: 'calendar' },
    ] }],
  },
  f1: {
    title: 'f1', home: '/', icon: 'flag',
    tagline: 'A little friendly competition.',
    note: ['Back your instincts.', 'Follow the season.'], account: 'Paddock member',
    footer: 'BRECK F1', footerNote: 'Made for the long game.',
    groups: [
      { label: 'WORKSPACE', items: [
        { href: '/', label: 'Overview', icon: 'grid' },
        { href: '/users', label: 'Members', icon: 'users' },
        { href: '/account', label: 'Account settings', icon: 'grid', signedIn: true },
        { href: '/admin', label: 'Admin console', icon: 'users', admin: true },
      ] },
      { label: 'PLAY TOGETHER', items: [
        { href: '/f1', label: 'F1 predictions', icon: 'flag' },
        { href: '/f1/simulations', label: 'Simulations', icon: 'bolt' },
        { href: '/f1/seasons', label: 'Past seasons', icon: 'trophy' },
        { href: '/about', label: 'About the app', icon: 'info' },
      ] },
    ],
  },
  wallet: {
    title: 'wallet', home: '/', icon: 'wallet',
    tagline: 'Your everyday, accounted for.',
    note: ['Small steps.', 'Clearer picture.'], account: 'Personal wallet',
    footer: 'BRECK WALLET', footerNote: 'Your bills are private to your account.',
    groups: [
      { label: 'YOUR SPACE', items: [
        { href: '/', label: 'Overview', icon: 'overview' },
        { href: '/bills', label: 'All bills', icon: 'bills' },
        { href: '/recurring-bills', label: 'Recurring bills', icon: 'recurring' },
        { href: '/statistics', label: 'Statistics', icon: 'statistics' },
      ] },
      { label: 'MANAGE', items: [
        { href: '/settings', label: 'Settings', icon: 'settings', nested: true },
      ] },
    ],
  },
};

function Anchor({ href, children, ...props }) {
  return <a href={href} {...props}>{children}</a>;
}

export function AppBrand({ app, Icon, LinkComponent = Anchor }) {
  const config = appShells[app];
  return <LinkComponent href={config.home} className="shell-brand" data-app={app} aria-label={`${config.title === 'f1' ? 'F1' : config.title} home`}>
    <span className="shell-brand-icon"><Icon name={config.icon} size={27}/></span>
    <span className="shell-brand-name">{config.title}<span className="shell-brand-dot">.</span><small>BY BRECK</small></span>
  </LinkComponent>;
}

export default function AppShell({ app, Icon, LinkComponent = Anchor, activePath, signedIn = true, user,
  navBadges = {}, actions, children, overlays }) {
  const config = appShells[app];
  const name = user?.displayName || user?.username || 'Your account';
  return <div className="breck-shell" data-app={app}>
    <a href="#main" className="shell-skip-link" onClick={event => {
      event.preventDefault();
      document.getElementById('main')?.focus();
    }}>Skip to content</a>
    <aside className="shell-sidebar">
      <AppBrand app={app} Icon={Icon} LinkComponent={LinkComponent}/>
      <nav className="shell-nav" aria-label="Main navigation">
        {config.groups.map(group => <div className="shell-nav-group" key={group.label}>
          <div className="shell-nav-caption">{group.label}</div>
          {group.items.filter(item => (!item.signedIn || signedIn) && (!item.admin || (signedIn && user?.role === 'ADMIN'))).map(item => {
            const active = activePath === item.href || (item.nested && activePath?.startsWith(item.href + '/'));
            const badge = navBadges[item.badge];
            return <LinkComponent key={item.href} href={item.href} aria-current={active ? 'page' : undefined} className={`shell-nav-link${active ? ' active' : ''}`}>
              <Icon name={item.icon}/><span>{item.label}</span>{badge > 0 && <b className="shell-nav-badge">{badge}</b>}
            </LinkComponent>;
          })}
        </div>)}
      </nav>
      <div className="shell-note"><Icon name={config.icon} size={24}/><p>{config.note[0]}<br/>{config.note[1]}</p></div>
      <div className={`shell-account${signedIn ? '' : ' shell-account-guest'}`}>
        {signedIn ? <><span className="shell-avatar">{name.slice(0, 1).toUpperCase()}</span><div><strong>{name}</strong><small>{config.account}</small></div></> :
          <LinkComponent href="/login" className="shell-sign-in">Sign in <Icon name="arrow" size={16}/></LinkComponent>}
      </div>
    </aside>
    <div className="shell-body">
      <header className="shell-topbar">
        <span className="shell-tagline"><Icon name={config.icon} size={16}/>{config.tagline}</span>
        <div className="shell-actions">{actions}</div>
      </header>
      <main id="main" tabIndex={-1} className="main-content">{children}</main>
      <footer className="shell-footer">{config.footer}<span>{config.footerNote}</span></footer>
    </div>
    {overlays}
  </div>;
}
